export const legal = {
  privacy: {
    it: {
      overline: "Documenti Legali",
      title: "Privacy Policy",
      lead: "Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR). Ultimo aggiornamento: ottobre 2026.",
      sections: [
        {
          heading: "Titolare del trattamento",
          paragraph:
            "Il titolare del trattamento dei dati è Aldebran — Engineering Group, con sede in Via Dalmine 10/A, 24035 Curno (BG), P.IVA 02693840163, contattabile all'indirizzo email info@aldebran.com.",
        },
        {
          heading: "Dati raccolti",
          paragraph:
            "Attraverso il modulo contatti del sito raccogliamo unicamente i dati che l'utente inserisce volontariamente:",
          list: [
            "Nome e cognome",
            "Nome dell'azienda (facoltativo)",
            "Indirizzo email",
            "Servizio di interesse (facoltativo)",
            "Contenuto del messaggio",
          ],
        },
        {
          heading: "Finalità e base giuridica",
          paragraph:
            "I dati sono trattati esclusivamente per rispondere alle richieste di contatto e consulenza inviate dall'utente. La base giuridica del trattamento è l'esecuzione di misure precontrattuali richieste dall'interessato (art. 6, par. 1, lett. b GDPR).",
        },
        {
          heading: "Modalità del trattamento e conservazione",
          paragraph:
            "I messaggi inviati tramite il modulo vengono recapitati via email al nostro team e conservati in un archivio protetto per il tempo necessario a gestire la richiesta. I dati non sono ceduti a terzi, non sono utilizzati per finalità di marketing e non sono soggetti a processi decisionali automatizzati.",
        },
        {
          heading: "Diritti dell'interessato",
          paragraph:
            "L'utente può in qualsiasi momento esercitare i diritti previsti dagli artt. 15-22 del GDPR — accesso, rettifica, cancellazione, limitazione, portabilità e opposizione — scrivendo a info@aldebran.com. È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali.",
        },
      ],
    },
    en: {
      overline: "Legal Documents",
      title: "Privacy Policy",
      lead: "Information on the processing of personal data pursuant to Regulation (EU) 2016/679 (GDPR). Last updated: October 2026.",
      sections: [
        {
          heading: "Data controller",
          paragraph:
            "The data controller is Aldebran — Engineering Group, with registered office at Via Dalmine 10/A, 24035 Curno (BG), Italy, VAT 02693840163, reachable at info@aldebran.com.",
        },
        {
          heading: "Data collected",
          paragraph:
            "Through the site's contact form we collect only the data voluntarily entered by the user:",
          list: [
            "Full name",
            "Company name (optional)",
            "Email address",
            "Service of interest (optional)",
            "Message content",
          ],
        },
        {
          heading: "Purpose and legal basis",
          paragraph:
            "Data is processed exclusively to respond to contact and consultation requests sent by the user. The legal basis is the execution of pre-contractual measures requested by the data subject (art. 6, par. 1, lett. b GDPR).",
        },
        {
          heading: "Processing methods and retention",
          paragraph:
            "Messages sent through the form are delivered by email to our team and stored in a protected archive for the time needed to handle the request. Data is not transferred to third parties, not used for marketing purposes and not subject to automated decision-making.",
        },
        {
          heading: "Rights of the data subject",
          paragraph:
            "The user may at any time exercise the rights provided by articles 15-22 of the GDPR — access, rectification, erasure, restriction, portability and objection — by writing to info@aldebran.com. It is also possible to lodge a complaint with the Italian Data Protection Authority (Garante).",
        },
      ],
    },
  },
  cookies: {
    it: {
      overline: "Documenti Legali",
      title: "Cookie Policy",
      lead: "Informazioni sull'uso dei cookie su questo sito. Ultimo aggiornamento: ottobre 2026.",
      sections: [
        {
          heading: "Cosa sono i cookie",
          paragraph:
            "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi allo stesso sito alla visita successiva.",
        },
        {
          heading: "Cookie utilizzati da questo sito",
          paragraph:
            "Questo sito utilizza esclusivamente cookie tecnici, necessari al funzionamento e alla sicurezza della piattaforma (ad esempio quelli dell'infrastruttura di hosting e distribuzione dei contenuti).",
          list: [
            "Nessun cookie di profilazione",
            "Nessun cookie pubblicitario o di marketing",
            "Nessun cookie di analisi o statistiche di terze parti",
            "Nessuna cessione di dati di navigazione a terzi",
          ],
        },
        {
          heading: "Consenso",
          paragraph:
            "Poiché il sito utilizza solo cookie tecnici, ai sensi della normativa vigente non è richiesto il consenso preventivo dell'utente e non viene mostrato alcun banner.",
        },
        {
          heading: "Come disabilitare i cookie",
          paragraph:
            "È possibile disabilitare o eliminare i cookie dalle impostazioni del proprio browser. La disabilitazione dei cookie tecnici può compromettere il corretto funzionamento di alcune parti del sito.",
        },
        {
          heading: "Contatti",
          paragraph:
            "Per qualsiasi domanda relativa a questa Cookie Policy è possibile scrivere a info@aldebran.com.",
        },
      ],
    },
    en: {
      overline: "Legal Documents",
      title: "Cookie Policy",
      lead: "Information about the use of cookies on this site. Last updated: October 2026.",
      sections: [
        {
          heading: "What cookies are",
          paragraph:
            "Cookies are small text files that visited websites send to the user's device, where they are stored and then retransmitted to the same site on the next visit.",
        },
        {
          heading: "Cookies used by this site",
          paragraph:
            "This site uses exclusively technical cookies, necessary for the operation and security of the platform (for example those of the hosting and content delivery infrastructure).",
          list: [
            "No profiling cookies",
            "No advertising or marketing cookies",
            "No third-party analytics or statistics cookies",
            "No transfer of browsing data to third parties",
          ],
        },
        {
          heading: "Consent",
          paragraph:
            "Since the site uses only technical cookies, under current legislation no prior user consent is required and no banner is shown.",
        },
        {
          heading: "How to disable cookies",
          paragraph:
            "Cookies can be disabled or deleted from your browser settings. Disabling technical cookies may affect the proper functioning of some parts of the site.",
        },
        {
          heading: "Contacts",
          paragraph:
            "For any questions regarding this Cookie Policy, you can write to info@aldebran.com.",
        },
      ],
    },
  },
};
